import * as yup from "yup";

import { DireccionSchema } from "./DireccionSchema";
import { CUITRegex } from "../utils/regex";

export const EmpresaSchema = yup.object().shape({
  CUIT: yup
    .string()
    .length(11, "errors.empresa.CUIT.length")
    .matches(CUITRegex, "errors.empresa.CUIT.regex")
    .required("errors.empresa.CUIT.required"),
  razonSocial: yup
    .string()
    .uppercase()
    .max(100, "errors.empresa.razonSocial.max")
    .required("errors.empresa.razonSocial.required"),
  nombreFantasia: yup
    .string()
    .max(100, "errors.empresa.nombreFantasia.")
    .optional()
    .nullable(),
  domicilio: DireccionSchema.required("errors.empresa.domicilio.required"),
});
